function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "1F5561A0-C459-4994-AD3A-8BD579F8D826");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-942.000000, -787.000000)",
  fill: "#8993A4"
}, React.createElement("g", {
  id: "2-drop",
  transform: "translate(942.000000, 787.000000)"
}, React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "4.5 1 4.98809 0.430558 4.5 0.012192 4.01191 0.430558"
}), React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "4.5 10 4.01191 10.56944 4.5 10.98781 4.98809 10.56944"
}), React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "1.488094 4.56944 4.98809 1.569442 4.01191 0.430558 0.511906 3.43056"
}), React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "4.01191 1.569442 7.51191 4.56944 8.48809 3.43056 4.98809 0.430558"
}), React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "0.511906 7.56944 4.01191 10.56944 4.98809 9.43056 1.488094 6.43056"
}), React.createElement("polygon", {
  id: "path0_stroke-path",
  points: "4.98809 10.56944 8.48809 7.56944 7.51191 6.43056 4.01191 9.43056"
}))));

var SvgDropdownIcon = function SvgDropdownIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "9px",
    height: "11px",
    viewBox: "0 0 9 11",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDropdownIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown-icon.ada7b213.svg";
export { ForwardRef as ReactComponent };